var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "logreg",
    class: {
      showContent: _vm.showContent
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }), _vm._v(" "), _vm.isShowLogin ? _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('select-way', {
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "selectWay": _vm.selectWayHandle
    }
  }), _vm._v(" "), _vm.showContent && _vm.wayType === 'email' ? _c('email-way', {
    ref: "emailWay",
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "showForget": _vm.showForgetHandle,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }) : _vm._e(), _vm._v(" "), _vm.showContent && _vm.wayType === 'phone' ? _c('phone-way', {
    ref: "phoneWay",
    attrs: {
      "wayType": _vm.wayType
    },
    on: {
      "showForget": _vm.showForgetHandle,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }) : _vm._e(), _vm._v(" "), _c('third-way', {
    attrs: {
      "clientId": _vm.clientId,
      "thirdHost": _vm.thirdHost,
      "oldThirdHost": _vm.oldThirdHost,
      "wayType": _vm.wayType
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_c('i18n', {
    attrs: {
      "path": _vm.$loginLangPrefix('userSign.termstip'),
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "place": "term",
      "target": "_blank",
      "href": "/protocol/terms.html"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.term'))))]), _vm._v(" "), _c('a', {
    attrs: {
      "place": "privacy",
      "target": "_blank",
      "href": "/protocol/privacy.html"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.privacy'))))])])], 1)], 1) : _vm._e(), _vm._v(" "), !_vm.isShowLogin ? _c('div', {
    staticClass: "forget"
  }, [_vm.forgetState === 'email' ? _c('email-forget', {
    attrs: {
      "wayType": _vm.wayType,
      "loginName": _vm.loginName
    },
    on: {
      "selectWay": _vm.selectWayHandle,
      "success": _vm.success
    }
  }) : _vm._e(), _vm._v(" "), _vm.forgetState === 'phone' ? _c('phone-forget', {
    attrs: {
      "wayType": _vm.wayType,
      "loginName": _vm.loginName,
      "itc": _vm.itc,
      "country": _vm.country
    },
    on: {
      "selectWay": _vm.selectWayHandle,
      "success": _vm.success
    }
  }) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };